export default __webpack_public_path__ + "images/b0fc09a3a88fa188bd0a8138f1ec5cb9-kareem-icon.svg";